import React, { useState, useEffect, useRef } from 'react';
import Project_popup_header from '../Component/Header/Project_popup_header';
import back_arrow from "../assets/svg/back-arrow.svg";
import plus_icon from "../assets/svg/plus_icon.svg";
import { useNavigate } from "react-router-dom";
import "../styles/project_popup.css"
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import AsyncSelect from 'react-select/async';
import Select, { components } from "react-select";
import axiosInstance from '../axiosInstance';
import { fetchWithAuth } from '../fetchWithAuth';
import CommonFooter from '../CommonFooter/CommonFooter';

const ProjectCreation = () => {
  const navigate = useNavigate();
  const locationData = useLocation();
  const projectData = locationData.state?.project || {};
  const isUpdateMode = !!locationData.state?.project;

  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const dropdownRef = useRef(null);
  const [jobOptions, setJobOptions] = useState([]);
  const [chargeOptions, setChargeOptions] = useState([]);
  const [ModelOptions, setModelOptions] = useState([]);
  const [projectCode, setProjectCode] = useState([]);
  const [projectName, setProjectName] = useState([]);
  const [customerContact, setCustomerContact] = useState([]);
  const [projectManShift, setProjectManshift] = useState([]);
  const [confirmation, setConfirmation] = useState([]);
  const [projectReference, setProjectReference] = useState([]);
  const [location, setLocation] = useState([]);
  const [proofnumber, setProofNumber] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [backdatedDays, setBackdatedDays] = useState(null);
  const [selectedCharges, setSelectedCharges] = useState([]);
  const [plantCode, setPlantCode] = useState(null);
  const [businessPlace, setBusinessPlace] = useState("");
  const [divisionType, setDivisionType] = useState([]);
  const [chargeItems, setChargeItems] = useState([
    {
      charge_id: '',
      label: '',
      // supporting_doc: false,
      cost_supporting_doc: false,
      sales_supporting_doc: false
    },
  ]);
  const [jobTypeInputValue, setJobTypeInputValue] = useState('');
  const [multiSelectedCharges, setMultiSelectedCharges] = useState([]);
  const [chargeInputValue, setChargeInputValue] = useState('');
  const [profitCenter, setProfitCenter] = useState(null);
  const [costCenter, setCostCenter] = useState(null);
  const [region, setRegion] = useState("");
  const [mailIds, setMailIds] = useState([]);
  const [mailInput, setMailInput] = useState("");
  const [profitCenterOptions, setProfitCenterOptions] = useState([]);
  const [costCenterOptions, setCostCenterOptions] = useState([]);
  const [locationOpt, setLocationOpt] = useState(null);
  const [cityOpt, setCityOpt] = useState(null);
  const [stateOpt, setStateOpt] = useState(null);
  const [countryOpt, setCountryOpt] = useState(null);
  const [locationInput, setLocationInput] = useState("");
  const [isNewLocation, setIsNewLocation] = useState(false);
  const [cityInput, setCityInput] = useState("");
  const [stateInput, setStateInput] = useState("");
  const [countryInput, setCountryInput] = useState("");
  const [isNewCity, setIsNewCity] = useState(false);
  const [isNewState, setIsNewState] = useState(false);
  const [isNewCountry, setIsNewCountry] = useState(false);
  const [zoneOpt, setZoneOpt] = useState(null);
  const [zoneInput, setZoneInput] = useState("");
  const [isNewZone, setIsNewZone] = useState(false);
  const [errors, setErrors] = useState({});

  const divisionOptions = [
    { label: "SCS", value: "scs" },
    { label: "FF", value: "ff" }
  ];

  useEffect(() => {
    console.log("projectdata....", projectData);
    if (projectData) {
      console.log("inside ifprojectdata....", projectData);
      setProjectCode(projectData.code || "");
      setProjectName(projectData.name || "");
      setDivisionType(
        Array.isArray(projectData.division_type)
          ? projectData.division_type
          : projectData.division_type
            ? [projectData.division_type]
            : []
      );
      setCustomerContact(projectData.customerCode || "");
      setCustomer(projectData.customer_name || "");
      setConfirmation(projectData.confirmation || "");
      setProjectReference(projectData.project_reference || "");
      setProjectManshift(projectData.project_man_shift || "");
      setLocation(projectData.location || "");
      setProofNumber(projectData.proofnumber || "");
      setSelectedModel(projectData.modelCode || "");
      setPlantCode(
        projectData.plant_code
          ? {
            label: projectData.plant_code,
            value: projectData.plant_id
          }
          : null
      );

      if (projectData.template_id) {
        setSelectedTemplate({
          value: projectData.template_id,
          label: projectData.templateName || `Template ${projectData.template_id}`,
          model: projectData.modelId 
        });
      }

      setBusinessPlace(projectData.business_place_code || "");
      setBackdatedDays(projectData.backdated_days);
      setModelOptions([])
      setSelectedJobs(projectData.jobtype?.map(j => j.value) || []);
      if (projectData.location_id) {
        const locationObj = {
          value: projectData.location_id,
          label: projectData.location_name,
          city_id: projectData.city_id,
          city_name: projectData.city_name,
          state_id: projectData.state_id,
          state_name: projectData.state_name,
          country_id: projectData.country_id,
          country_name: projectData.country_name,
          zone: projectData.region
        };

        setLocationOpt(locationObj);
        setCityOpt({
          value: projectData.city_id,
          label: projectData.city_name
        });

        setStateOpt({
          value: projectData.state_id,
          label: projectData.state_name
        });

        setCountryOpt({
          value: projectData.country_id,
          label: projectData.country_name
        });
      }

      if (projectData.profit_centre_id) {
        setProfitCenter({
          value: projectData.profit_centre_id,
          label: projectData.profit_centre
        });
      } else {
        setProfitCenter(null);
      }
      if (projectData.cost_centre_id) {
        setCostCenter({
          value: projectData.cost_centre_id,
          label: projectData.cost_centre
        });
      } else {
        setCostCenter(null);
      }
      setRegion(
        projectData.region
          ? projectData.region.charAt(0).toUpperCase() + projectData.region.slice(1).toLowerCase()
          : ""
      );
      if (projectData.mail_ids) {
        setMailIds(
          projectData.mail_ids
            .split(",")
            .map(m => m.trim())
            .filter(Boolean)
        );
      } else {
        setMailIds([]);
      }



      if (Array.isArray(projectData.jobtype)) {
        const jobIds = projectData.jobtype.map(j => j.value);
        setSelectedJobs(jobIds);
      }

      if (Array.isArray(projectData.charges)) {
        const formattedCharges = projectData.charges.map(c => ({
          charge_id: String(c.value), // fix here
          label: c.label || '',
          // supporting_doc: c.supporting_doc || false,
          cost_supporting_doc: c.cost_supporting_doc || false,
          sales_supporting_doc: c.sales_supporting_doc || false
        }));
        setChargeItems(formattedCharges);
        setSelectedCharges(formattedCharges.map(item => ({
          value: item.charge_id,
          label: item.label || `Charge ${item.charge_id}`
        })));
      }
    }
  }, []);


  useEffect(() => {
    const fetchJobs = async () => {
      try {

        const response = await axiosInstance.get(
          `/jobtype/getoveralljobtype`
        );

        console.log(response.data.jobtypes)
        if (response.data && Array.isArray(response.data.jobtypes)) {
          const fetchedJobs = response.data.jobtypes
          console.log("jobtypecalled");
          console.log(response.data)
          setJobOptions(fetchedJobs);

        }
      } catch (error) {
        console.error("Failed to fetch job options:", error);
      }
    };

    fetchJobs();
  }, []);

  useEffect(() => {
    const fetchCharges = async () => {
      try {

        const response = await axiosInstance.get(
          `/charge/getcharges`
        );

        console.log(response.data.jobtypes)
        if (response.data && Array.isArray(response.data.charges)) {
          console.log("jobtypecalled");
          console.log(response.data)
          setChargeOptions(response.data.charges); // Directly using response since it has label + value
          const categories = response?.data?.charge_id || [];
          if (projectData && projectData.charge_id) {
            const matchedCategory = categories.find(cat => cat.value === projectData.charge_id);
            if (matchedCategory) {
              setChargeOptions(matchedCategory.value);
            }
          }
        }
      } catch (error) {
        console.error("Failed to fetch job options:", error);
      }
    };

    fetchCharges();
  }, []);

  useEffect(() => {
    const fetchModel = async () => {
      try {

        const response = await axiosInstance.get(
          `/costsolution/model/getModel`
        );

        console.log(response.data.jobtypes)
        if (response.data && Array.isArray(response.data.model)) {
          const fetchedModels = response.data.model;

          // Step 1: Set options
          setModelOptions(fetchedModels);

          // Step 2: If in edit mode and projectData exists
          if (projectData && projectData.modelId) {
            // Find the matching model by ID
            const matchedModel = fetchedModels.find(
              (model) => model.value === projectData.modelId
            );

            // Set selectedModel only after options are loaded
            if (matchedModel) {
              setSelectedModel(matchedModel.value);
            }
          }
        }

      } catch (error) {
        console.error("Failed to fetch job options:", error);
      }
    };

    fetchModel();
  }, []);

  // Toggle dropdown visibility
  const toggleJobDropdown = () => {
    setIsJobDropdownOpen(!isJobDropdownOpen);
  };

  // Handle job selection
  const handleJobCheckboxChange = (jobId) => {
    setSelectedJobs(prev =>
      prev.includes(jobId)
        ? prev.filter(id => id !== jobId)
        : [...prev, jobId]
    );
  };

  // Remove selected job
  const handleRemoveJob = (jobId) => {
    setSelectedJobs(prev => prev.filter(id => id !== jobId));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsJobDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  // const handleSubmit = async () => {
  //   if (!projectCode.trim()) {
  //     toast.error("Project Code is required");
  //     return;
  //   }

  //   if (!projectName.trim()) {
  //     toast.error("Project Name is required");
  //     return;
  //   }

  //   const payload = {
  //     code: projectCode,
  //     name: projectName,
  //     // customerCode: customerContact,
  //     // confirmation: confirmation,
  //     projectReference: projectReference,
  //     customerName: customer,
  //     project_man_shift: projectManShift,
  //     modelCode: selectedModel,
  //     // location: location,
  //     // proofnumber: proofnumber,
  //     job_type: selectedJobs.map(item => ({
  //       "job_type_id": item
  //     })),
  //     charges: chargeItems.map(item => ({
  //       charge_id: parseInt(item.charge_id, 10),
  //       supporting_doc: item.supporting_doc || false
  //     })),
  //   };

  //   console.log("project payload", payload)

  //   try {

  //     // fetch("https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/save", {
  //     //   method: "POST",
  //     //   headers: {
  //     //     "Content-Type": "application/json"
  //     //   },
  //     //   body: JSON.stringify(payload)
  //     // })

  //     const response = await fetchWithAuth(
  //       "/costsolution/projects/save",
  //       {
  //         method: "POST",
  //         body: JSON.stringify(payload),
  //         headers: {
  //           "Content-Type": "application/json"
  //         }
  //       }
  //     );
  //     const data = await response.json();
  //     console.log("Success:", data);

  //     if (data.success === true) {
  //       toast.success("Saved successfully!");
  //       setTimeout(() => {
  //         navigate("/projects");
  //       }, 1500);
  //     }
  //   } catch (err) {
  //     console.error("Error:", err);
  //   };
  // };


  const handleSubmit = async () => {
    if (!validateForm()) return;

    const validChargeItems = chargeItems.filter(item => item.charge_id && item.charge_id !== '');
    if (validChargeItems.length === 0) {
      toast.error("At least one Charge must be selected");
      return;
    }
    let finalLocationId = locationOpt?.value || null;
    const cityId = cityOpt?.value;

    if (isNewLocation && locationInput && cityOpt && stateOpt && countryOpt) {
      try {
        const res = await axiosInstance.post("/create_location", {
          name: locationInput,
          city_id: cityId
        });

        if (res.data.success) {
          finalLocationId = res.data.data.value;
          toast.success(`New location "${locationInput}" created`);
        } else {
          toast.error("Failed to create new location");
          return;
        }
      } catch (err) {
        console.error("Location create failed", err);
        toast.error("Failed to create new location");
        return;
      }
    }

    const payload = {
      code: projectCode,
      name: projectName,
      division_type: divisionType,
      projectReference: projectReference,
      customerName: customer,
      project_man_shift: projectManShift,
      plant_id: plantCode?.value || null,
      modelCode: selectedModel,
      backdated_days: backdatedDays,
      profit_centre_id: profitCenter?.value || null,
      cost_centre_id: costCenter?.value || null,
      region: region,
      business_place_code: businessPlace,
      location_id: finalLocationId,
      city_id: cityOpt?.value || null,
      state_id: stateOpt?.value || null,
      country_id: countryOpt?.value || null,
      template_id: selectedTemplate?.value || null,
      mail_ids: mailIds.join(","),
      job_type: selectedJobs.map(item => ({
        job_type_id: item
      })),
      charges: validChargeItems.map(item => ({
        charge_id: parseInt(item.charge_id, 10),
        // supporting_doc: item.supporting_doc || false,
        cost_supporting_doc: item.cost_supporting_doc || false,
        sales_supporting_doc: item.sales_supporting_doc || false
      })),
    };

    console.log("project payload", payload);

    try {
      const response = await axiosInstance.post("/costsolution/projects/save", payload);
      console.log("Success:", response.data);

      if (response.data.success === true) {
        toast.success(response.data.message || "Project saved successfully!");
        setTimeout(() => navigate("/projects"), 1500);
      } else {
        toast.error(response.data.message || "Failed to save project");
      }
    } catch (err) {
      console.error("Error:", err);

      const errorMessage =
        err.response?.data?.message ||
        err.response?.data?.errors?.[Object.keys(err.response?.data?.errors || {})[0]]?.[0] ||
        "Something went wrong while saving.";

      toast.error(errorMessage);
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;

    const validChargeItems = chargeItems.filter(item => item.charge_id && item.charge_id !== '');

    let finalLocationId = locationOpt?.value || null;
    const cityId = cityOpt?.value;

    if (isNewLocation && locationInput && cityOpt && stateOpt && countryOpt) {
      try {
        const res = await axiosInstance.post("/create_location", {
          name: locationInput,
          city_id: cityId
        });

        if (res.data.success) {
          finalLocationId = res.data.data.value;
          setIsNewLocation(false);
          toast.success(`New location "${locationInput}" created`);
        } else {
          toast.error("Failed to create new location");
          return;
        }
      } catch (err) {
        console.error("Location create failed", err);
        toast.error("Failed to create new location");
        return;
      }
    }
    const payload = {
      id: projectData.id, // Make sure to include the project ID for update
      code: projectCode,
      name: projectName,
      division_type: divisionType,
      // customerCode: customerContact,
      // confirmation: confirmation,
      projectReference: projectReference,
      customerName: customer,
      project_man_shift: projectManShift,
      modelCode: selectedModel,
      plant_id: plantCode && plantCode.value ? plantCode.value : null,
      backdated_days: backdatedDays,
      modelID: projectCode.modelID,
      profit_centre_id: profitCenter?.value || null,
      cost_centre_id: costCenter?.value || null,
      region: region,
      location_id: finalLocationId,
      city_id: cityOpt?.value || null,
      state_id: stateOpt?.value || null,
      country_id: countryOpt?.value || null,
      business_place_code: businessPlace,
      template_id: selectedTemplate?.value || null,
      mail_ids: mailIds.join(","),
      // location: location,
      job_type: selectedJobs.map(item => ({
        "job_type_id": item
      })),
      charges: validChargeItems.map(item => ({
        charge_id: parseInt(item.charge_id, 10),
        // supporting_doc: item.supporting_doc,
        cost_supporting_doc: item.cost_supporting_doc || false,
        sales_supporting_doc: item.sales_supporting_doc || false
      })),
    };

    try {
      // const response = await axios.put(
      //   "https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/update",
      //   payload
      // );

      const response = await axiosInstance.put(
        `/costsolution/projects/update`, payload
      );

      if (response.data.success) {
        toast.success("Project updated successfully!");
        setTimeout(() => {
          navigate("/projects");
        }, 1500);
      } else {
        throw new Error(response.data.message || "Failed to update project");
      }
    } catch (err) {
      console.error("Error:", err);

      const errorMessage =
        err.response?.data?.message ||
        err.response?.data?.errors?.[Object.keys(err.response?.data?.errors || {})[0]]?.[0] ||
        "Something went wrong while saving.";

      toast.error(errorMessage);
    }
  };

  const [allCharges, setAllCharges] = useState([]);

  const loadMultiChargeOptions = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get(`/charge/autocompletecharges`, {
        params: { term: inputValue || '' },
      });

      const options = res.data?.autosuggestion || [];
      const selectedChargeIds = chargeItems.map(item => item.charge_id);

      const filteredOptions = options.filter(
        option => !selectedChargeIds.includes(option.value.toString())
      );

      const mapped = filteredOptions.map((item) => ({
        label: item.label,
        value: item.value,
      }));

      if (!inputValue) {
        // store all charges for defaultOptions
        setAllCharges(mapped);
      }

      callback(mapped);
    } catch (error) {
      console.error("Charge code suggestion error:", error);
      callback([]);
    }
  };


  const loadChargeOptions = async (inputValue, callback) => {
    try {
      // const res = await axios.get(
      //     "https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/charge/autocompletecharges",
      //     {
      //         params: { term: inputValue || '' },
      //         headers: { "Content-Type": "application/json" },
      //     }
      // );

      const res = await axiosInstance.get(
        `/charge/autocompletecharges`,
        {
          params: { term: inputValue || '' },
        }
      );


      const options = res.data?.autosuggestion || [];

      // Filter out charges that are already selected
      const selectedChargeIds = chargeItems.map(item => item.charge_id);
      const filteredOptions = options.filter(
        option => !selectedChargeIds.includes(option.value.toString())
      );

      const mapped = filteredOptions.map((item) => ({
        label: item.label,
        value: item.value,
      }));

      callback(mapped);
    } catch (error) {
      console.error("Charge code suggestion error:", error);
      callback([]);
    }
  };

  const loadJobTypes = async (inputValue) => {

    if (!divisionType.length) return [];

    try {
      const res = await axiosInstance.get(
        `/jobtype/autosuggestion`,
        {
          params: {
            term: inputValue || "",
            division_type: divisionType
          }
        }
      );

      const data = res.data;

      if (data.success && Array.isArray(data.autosuggestion)) {
        return data.autosuggestion.map(item => ({
          label: item.label,
          value: item.value
        }));
      }

      return [];
    } catch (error) {
      console.error("Job type suggestion error:", error);
      return [];
    }
  };

  useEffect(() => {
    if (!isUpdateMode) {
      setSelectedJobs([]);
    }
  }, [divisionType]);

  const isValidEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|org|in|tech|co|net|edu|io)$/;

    if (!regex.test(email)) return false;
    if (email.includes("..")) return false;
    if (email.endsWith(".")) return false;
    if (/[^a-zA-Z0-9._%+-@]/.test(email)) return false;
    return true;
  };


  const handleMailKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();

      const value = mailInput.trim().replace(/,$/, "");
      if (!value) return;

      if (!isValidEmail(value)) {
        toast.error("Invalid email format");
        return;
      }

      if (mailIds.includes(value)) {
        toast.error("Email already added");
        return;
      }

      setMailIds([...mailIds, value]);
      setMailInput("");
    }
  };

  const removeMail = (email) => {
    setMailIds(mailIds.filter(m => m !== email));
  };

  const loadProfitCenters = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get(
        "/projects/get_profit_centre",
        { params: { term: inputValue || "" } }
      );

      const options = (res.data?.autosuggestion || []).map(item => ({
        value: item.value,
        label: item.label
      }));

      // ⭐ store full list for click
      if (!inputValue) {
        setProfitCenterOptions(options);
      }

      callback(options);
    } catch (err) {
      console.error("Profit center error", err);
      callback([]);
    }
  };

  const loadCostCenters = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get(
        "/projects/get_cost_centre",
        { params: { term: inputValue || "" } }
      );

      const options = (res.data?.autosuggestion || []).map(item => ({
        value: item.value,
        label: item.label
      }));

      // ⭐ store full list for click
      if (!inputValue) {
        setCostCenterOptions(options);
      }

      callback(options);
    } catch (err) {
      console.error("Cost center error", err);
      callback([]);
    }
  };

  const loadLocationOptions = async (inputValue) => {
    try {
      const res = await axiosInstance.get("/get_location", {
        params: { term: inputValue || "" }
      });

      const data = res.data;
      const results = (data.success && Array.isArray(data.suggestionlist))
        ? data.suggestionlist.map((item) => ({
          label: item.label,
          value: item.value,
          city_id: item.city_id,
          city_name: item.city_name,
          state_id: item.state_id,
          state_name: item.state_name,
          country_id: item.country_id,
          country_name: item.country_name,
          zone: item.zones || "",
          business_place_code: item.business_place_code
        }))
        : [];

      if (inputValue) {
        return [
          ...results,
          { label: `+ Create "${inputValue}"`, value: null, __isNew__: true }
        ];
      }

      return results;
    } catch (err) {
      console.error("Location autosuggest error", err);
      return [];
    }
  };

  const loadCityOptions = async (inputValue) => {
    try {
      const res = await axiosInstance.get("/get_city", {
        params: { term: inputValue || "" }
      });

      const data = res.data;

      if (data.success && Array.isArray(data.suggestionlist)) {
        return data.suggestionlist.map(city => ({
          label: city.label,
          value: city.value,
          state_id: city.state_id,
          state_name: city.state_name,
          country_id: city.country_id,
          country_name: city.country_name,
          zone: city.zones,
          business_place_code: city.business_place_code
        }));
      }

      return [];
    } catch (err) {
      console.error("City autosuggest error", err);
      return [];
    }
  };

  const loadStateOptions = async (inputValue) => {
    try {
      const res = await axiosInstance.get("/get_state", {
        params: { term: inputValue || "" }
      });

      const data = res.data;

      if (data.success && Array.isArray(data.suggestionlist)) {
        return data.suggestionlist.map(state => ({
          label: state.label,
          value: state.value,
          country_id: state.country_id,
          country_name: state.country_name,
          zone: state.zones,
          business_place_code: state.business_place_code
        }));
      }
      return [];
    } catch (err) {
      console.error("State autosuggest error", err);
      return [];
    }
  };

  const loadCountryOptions = async (inputValue) => {
    try {
      const res = await axiosInstance.get("/get_country", {
        params: { term: inputValue || "" }
      });

      const data = res.data;

      if (data.success && Array.isArray(data.suggestionlist)) {
        return data.suggestionlist.map(country => ({
          label: country.label,
          value: country.value
        }));
      }

      return [];
    } catch (err) {
      console.error("Country autosuggest error", err);
      return [];
    }
  };


  const handleLocationChange = (selected) => {
    setLocationOpt(selected);

    if (selected) {
      setCityOpt({
        label: selected.city_name,
        value: selected.city_id
      });
      setStateOpt({
        label: selected.state_name,
        value: selected.state_id
      });
      setBusinessPlace(selected.business_place_code || "");
      setCountryOpt({
        label: selected.country_name,
        value: selected.country_id
      });
      setZoneOpt({ label: selected.zone, value: selected.zone });
      setRegion(selected.zone || "");
      setIsNewCity(false);
      setIsNewState(false);
      setIsNewCountry(false);
      setIsNewZone(false);
    } else {
      setCityOpt(null);
      setStateOpt(null);
      setCountryOpt(null);
      setZoneOpt(null);
      setRegion("");
      setBusinessPlace("")
    }
  };

  const handleCityChange = (selected) => {
    setCityOpt(selected);

    if (selected) {
      setStateOpt({
        label: selected.state_name,
        value: selected.state_id
      });

      setCountryOpt({
        label: selected.country_name,
        value: selected.country_id
      });

      setRegion(selected.zone || "");
      setBusinessPlace(selected.business_place_code || "");
      setIsNewState(false);
      setIsNewCountry(false);
    } else {
      setStateOpt(null);
      setCountryOpt(null);
      setBusinessPlace("");
      setRegion("");
    }
  };

  const handleStateChange = (selected) => {
    setStateOpt(selected);

    if (selected) {
      setCountryOpt({
        label: selected.country_name,
        value: selected.country_id
      });

      setRegion(selected.zone || "");
      setBusinessPlace(selected.business_place_code || "");
      setIsNewCountry(false);
      setIsNewZone(false);
    } else {
      setCountryOpt(null);
      setRegion("");
      setBusinessPlace("");
    }
  };

  const validateForm = () => {
    const newErrors = {};
    /*  if (!divisionType.length) newErrors.divisionType = "Division Type is required"; */
    if (!projectCode?.trim()) newErrors.projectCode = "Code is required";
    if (!projectName?.trim()) newErrors.projectName = "Name is required";

    /*  if (!plantCode) newErrors.plantCode = "Plant Code is required";
     if (!selectedJobs || selectedJobs.length === 0)
       newErrors.selectedJobs = "At least one Job Type is required"; */
    const validChargeItems = chargeItems.filter(i => i.charge_id);
    if (validChargeItems.length === 0)
      newErrors.charges = "At least one Charge is required";

    setErrors(newErrors);

    const firstError = Object.values(newErrors)[0];
    if (firstError) {
      toast.error(firstError);
    }

    return Object.keys(newErrors).length === 0;
  };

  const clearError = (field) => {
    setErrors(prev => {
      if (!prev[field]) return prev;
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });
  };

  useEffect(() => {
    setErrors(prev => {
      if (!Object.keys(prev).length) return prev;

      const updated = { ...prev };

      if (locationOpt || locationInput) delete updated.location;
      if (cityOpt) delete updated.city;
      if (stateOpt) delete updated.state;
      if (countryOpt) delete updated.country;
      if (region) delete updated.region;

      return updated;
    });
  }, [locationOpt, locationInput, cityOpt, stateOpt, countryOpt, region]);

  const handleDivisionToggle = (value) => {
    setDivisionType(prev => (prev === value ? "" : value));
  };

  const loadPlantCodes = async (inputValue) => {
    if (!divisionType.length) return [];

    try {
      const res = await axiosInstance.get("/plant_code/autosuggestion", {
        params: {
          term: inputValue || "",
          division_type: divisionType
        }
      });

      if (res.data.success) {
        return res.data.autosuggestion.map(item => ({
          label: item.label,
          value: item.value
        }));
      }

      return [];
    } catch (error) {
      console.error("Plant code autosuggest error", error);
      return [];
    }
  };

  const loadTemplateOptions = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get(
        `/costsolution/template/autosuggestion`,
        { params: { term: inputValue || "" } }
      );

      const options = (res.data?.autosuggestion || []).map(item => ({
        value: item.value,
        label: item.label,
        model: item.model
      }));

      callback(options);
    } catch (err) {
      console.error("Template autocomplete error", err);
      callback([]);
    }
  };

  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
            style={{ marginRight: 8 }}
          />
          {props.label}
        </div>
      </components.Option>
    );
  };


  return (
    <>
      <div className="project_popup">
        <Project_popup_header onSearch={null} disableSearch={true} />
        <div className="project_popup_header">
          <div className="project_popup_header_left">
            <img src={back_arrow} alt="Back Arrow" onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }} />
            <p className="new_cost_line">New Project</p>
          </div>
          <div className="project_popup_header_right">
            <button className="cancel_btn" onClick={() => navigate(-1)}>
              Cancel
            </button>
            {isUpdateMode ? (
              <button className="save_btn" onClick={handleUpdate}>
                Update
              </button>
            ) : (
              <button className="save_btn" onClick={handleSubmit}>
                Save
              </button>
            )}
          </div>
        </div>

        <div className="project_popup_project">
          <div className='project_popup_all_input'>
            {/* Grid container */}

            <div className='project_popup_grid'>

              {/* <div className='project_popup_input_list'>
                <p className="project_popup_project_text" >Division Type <span style={{ color: 'red' }}>*</span></p>
                <div className="project-input-error-wrapper">
                  <Select
                    isMulti
                    options={divisionOptions}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CheckboxOption }}
                    value={divisionOptions.filter(opt =>
                      divisionType.includes(opt.value)
                    )}
                    onChange={(selected) => {
                      const values = selected ? selected.map(item => item.value) : [];
                      setDivisionType(values);
                      clearError("divisionType");
                    }}
                    placeholder="Select Division Type"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "44px",
                        borderRadius: "12px",
                        fontSize: "13px",
                        width: "100%",
                        borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                        boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                        "&:hover": {
                          borderColor: "#454CF2",
                        },
                      }),
                      container: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                      menu: (base) => ({
                        ...base,
                        fontSize: "12px",
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "250px",
                        overflowY: "auto",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: '#F0F4F8',
                        borderRadius: '4px',
                        padding: '2px 6px',
                        margin: '2px',
                        maxWidth: '120px',
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: '#19324C',
                        fontSize: '12px',
                        fontWeight: 500
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        maxHeight: "35px",
                        height: "40px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        flexWrap: "wrap",
                        alignItems: "center",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: '#19324C',
                        ':hover': {
                          backgroundColor: 'transparent',
                          color: '#ff0000'
                        }
                      })
                    }}
                  />
                  {errors.divisionType && (
                    <span className="field-error">
                      {errors.divisionType}
                    </span>
                  )}
                </div>
              </div> */}

              {/* Row 1 */}
              <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Code <span style={{ color: 'red' }}>*</span></p>

                <div className="project-input-error-wrapper">
                  <input type="" placeholder='Enter Code' className="project-popup-input" value={projectCode} onChange={(e) => {
                    setProjectCode(e.target.value.trim());
                    clearError("projectCode");
                  }} />
                  {errors.projectCode && (
                    <span className="field-error">{errors.projectCode}</span>
                  )}
                </div>
              </div>
              <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Name <span style={{ color: 'red' }}>*</span></p>
                <div className="project-input-error-wrapper">
                  <input type="" placeholder='Enter Name' className="project-popup-input" value={projectName} onChange={(e) => {
                    setProjectName(e.target.value);
                    clearError("projectName");
                  }} />
                  {errors.projectName && (
                    <span className="field-error">{errors.projectName}</span>
                  )}
                </div>
              </div>

              <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Project Man Shift</p>
                <select className="project-popup-input" value={projectManShift} onChange={(e) => setProjectManshift(e.target.value)}>
                  <option value="0" disabled selected>Select</option>
                  <option value="1">Shift 1</option>
                  <option value="2">Shift 2</option>
                  <option value="3">Shift 3</option>
                </select>
              </div>

              {/* Row 2 */}
              <div className='project_popup_input_list'>
                <p className="project_popup_project_text" >Template</p>
                <div className="project-input-error-wrapper">
                  <AsyncSelect
                    value={selectedTemplate}
                    loadOptions={loadTemplateOptions}
                    onChange={(selected) => {
                      console.log('Selected template payload:', selected);
                      setSelectedTemplate(selected);
                      if (selected && selected.model) {
                        setSelectedModel(selected.model);
                      } else {
                        setSelectedModel("");
                      }
                    }}
                    placeholder="Search Template..."
                    cacheOptions
                    defaultOptions
                    isClearable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "40px",
                        borderRadius: "12px",
                        fontSize: "13px",
                        width: "100%",
                        borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                        boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                        "&:hover": { borderColor: "#454CF2" }
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      menu: (base) => ({
                        ...base,
                        fontSize: "13px",
                        zIndex: 10
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "220px",
                        overflowY: "auto"
                      })
                    }}
                  />
                </div>
              </div>

              <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Model</p>
                <select
                  className="project-popup-input"
                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}
                  disabled
                  style={{
                    backgroundColor: '#F5F7FA',
                    cursor: 'not-allowed'
                  }}
                >
                  <option value="" disabled selected>Select</option>
                  {ModelOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className='project_popup_input_list'>
                <p className="project_popup_project_text" >Project Reference</p>
                <input type="" placeholder='Enter Project Reference' className="project-popup-input" value={projectReference} onChange={(e) => setProjectReference(e.target.value)} />
              </div>
              {/*  <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Invoice Backdated Days</p>
                <input
                  type="number"
                  placeholder="Enter Backdated Days"
                  value={backdatedDays}
                  min={1}
                  max={7}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    if (value >= 1 && value <= 7) {
                      setBackdatedDays(value);
                    } else if (e.target.value === "") {
                      setBackdatedDays("");
                    }
                  }}
                  className="project-popup-input"
                />
              </div> */}

              {/* Row 3 */}
              <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Customer Name</p>
                <input type="" placeholder='Enter Customer Name' className="project-popup-input" value={customer} onChange={(e) => setCustomer(e.target.value)} />
              </div>
              {/* <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Plant Code <span style={{ color: 'red' }}>*</span></p>
                <div className="project-input-error-wrapper">
                  <AsyncSelect
                    key={Array.isArray(divisionType) ? divisionType.join("-") : ""}
                    value={plantCode}
                    loadOptions={loadPlantCodes}
                    onChange={(selected) => {
                      setPlantCode(selected);
                      clearError("plantCode");
                    }}
                    placeholder="Search Plant Code..."
                    cacheOptions
                    defaultOptions
                    isClearable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "40px",
                        borderRadius: "12px",
                        fontSize: "13px",
                        width: "100%",
                        borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                        boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                        "&:hover": {
                          borderColor: "#454CF2",
                        },
                      }),
                      container: (base) => ({
                        ...base,
                        width: '100%'
                      }),
                      menu: (base) => ({
                        ...base,
                        fontSize: '13px'
                      }),
                    }}
                  />
                  {errors.plantCode && (
                    <span className="field-error">{errors.plantCode}</span>
                  )}
                </div>
              </div> */}
              {/* <div className="project_popup_input_list" ref={dropdownRef}>
                <p className="project_popup_project_text">Jobs type <span style={{ color: 'red' }}>*</span></p>
                <div style={{ width: '100%' }}>
                  <AsyncSelect
                    key={divisionType.join("-")}
                    isMulti
                    value={[]} // Empty value to hide selected items in input
                    inputValue={jobTypeInputValue}
                    onChange={(selectedOptions) => {
                      // This will now properly handle multiple selections
                      const newSelectedJobs = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setSelectedJobs(newSelectedJobs);
                      clearError("selectedJobs");
                    }}
                    onInputChange={setJobTypeInputValue}
                    loadOptions={loadJobTypes}
                    placeholder="Search and select job types..."
                    cacheOptions
                    defaultOptions
                    closeMenuOnSelect={false} // Keep dropdown open after selection
                    hideSelectedOptions={false}
                    noOptionsMessage={({ inputValue }) =>
                      inputValue ? "No job types found" : "Type to search job types"
                    }
                    loadingMessage={() => "Searching..."}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        width: '100%',
                        minHeight: '40px',
                        borderRadius: '12px',
                        fontSize: '14px',
                        borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                        boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                        '&:hover': {
                          borderColor: '#454CF2'
                        }
                      }),
                      container: (base) => ({
                        ...base,
                        width: '100%'
                      }),
                      menu: (base) => ({
                        ...base,
                        fontSize: '14px'
                      }),
                      // Hide the multi-value indicators in the input
                      multiValue: () => ({
                        display: 'none'
                      }),
                      multiValueRemove: () => ({
                        display: 'none'
                      })
                    }}
                    components={{
                      DropdownIndicator: null,
                      IndicatorSeparator: null,
                      Option: ({ children, ...props }) => (
                        <components.Option {...props}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                              cursor: 'pointer'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              // Toggle selection for this option
                              setSelectedJobs(prev =>
                                prev.includes(props.value)
                                  ? prev.filter(id => id !== props.value)
                                  : [...prev, props.value]
                              );
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectedJobs.includes(props.value)}
                              readOnly
                              style={{
                                marginRight: '8px',
                                cursor: 'pointer'
                              }}
                            />
                            {children}
                          </div>
                        </components.Option>
                      )
                    }}
                  />
                  {errors.selectedJobs && (
                    <span className="field-error" style={{ marginTop: '5px' }}>{errors.selectedJobs}</span>
                  )}
                </div>
              </div>
              {/* Row 4 */}
              {/* <div className="project_popup_input_list">
                <p className="project_popup_project_text">Profit Center</p>
                <div className="project-input-error-wrapper">
                  <AsyncSelect
                    value={profitCenter}
                    loadOptions={loadProfitCenters}
                    onChange={(selected) => {
                      setProfitCenter(selected);
                      clearError("profitCenter");
                    }}
                  placeholder="Search Profit Center..."
                  cacheOptions
                  defaultOptions={profitCenterOptions}
                  onFocus={() => {
                    if (profitCenterOptions.length === 0) {
                      loadProfitCenters("", () => { });
                    }
                  }}
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "44px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                      boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                      "&:hover": { borderColor: "#454CF2" }
                    }),
                    container: base => ({ ...base, width: '100%' }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "12px",
                      zIndex: 10
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "220px",
                      overflowY: "auto"
                    })
                  }}
                />
                </div>
              </div>
              <div className="project_popup_input_list">
                <p className="project_popup_project_text">Cost Center</p>
                <div className="project-input-error-wrapper">
                  <AsyncSelect
                    value={costCenter}
                    loadOptions={loadCostCenters}
                    onChange={(selected) => {
                      setCostCenter(selected);
                      clearError("costCenter");
                    }}
                  placeholder="Search Cost Center..."
                  cacheOptions
                  defaultOptions={costCenterOptions}
                  onFocus={() => {
                    if (costCenterOptions.length === 0) {
                      loadCostCenters("", () => { });
                    }
                  }}
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "44px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                      boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                      "&:hover": { borderColor: "#454CF2" }
                    }),
                    container: base => ({ ...base, width: '100%' }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "12px",
                      zIndex: 10
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "220px",
                      overflowY: "auto"
                    })
                  }}
                />
                </div>
              </div> */}

              <div className="project_popup_input_list">
                <p className="project_popup_project_text">Location</p>
                <div className="project-input-error-wrapper">
                  <AsyncSelect
                    value={
                      locationOpt ||
                      (isNewLocation && locationInput
                        ? { label: locationInput, value: null }
                        : null)
                    }
                    loadOptions={loadLocationOptions}
                    onChange={(selected) => {
                      if (selected?.__isNew__) {
                        setIsNewLocation(true);
                        setLocationInput(selected.inputValue || locationInput);
                        setLocationOpt(null);
                      } else {
                        setIsNewLocation(false);
                        setLocationOpt(selected);
                        handleLocationChange(selected);
                        clearError("location");
                      }
                    }}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") {
                        setLocationInput(inputValue);
                        setIsNewLocation(false);
                        setLocationOpt(null);
                      }
                      return inputValue;
                    }}
                    placeholder="Search or type location"
                    noOptionsMessage={() => null}
                    onFocus={() => loadLocationOptions("")}
                    cacheOptions={false}
                    defaultOptions={true}
                    isClearable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "44px",
                        borderRadius: "12px",
                        fontSize: "14px",
                        borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                        boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                        "&:hover": { borderColor: "#454CF2" }
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      menu: (base) => ({
                        ...base,
                        fontSize: "12px",
                        zIndex: 10
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "220px",
                        overflowY: "auto"
                      }),
                      option: (base, { data }) => ({
                        ...base,
                        color: data.__isNew__ ? "#454CF2" : base.color,
                        fontWeight: data.__isNew__ ? 600 : base.fontWeight,
                        borderTop: data.__isNew__ ? "1px solid #E5E7EB" : "none",
                        cursor: "pointer"
                      })
                    }}
                  />
                  {isNewLocation && locationInput && (
                    <span style={{
                      fontSize: "12px",
                      color: "#454CF2",
                      marginTop: "4px",
                      display: "block"
                    }}>
                      ✦ New location "{locationInput}" will be created on Save
                    </span>
                  )}
                </div>
              </div>

              <div className="project_popup_input_list">
                <p className="project_popup_project_text">City</p>
                <div className="project-input-error-wrapper">
                  <AsyncSelect
                    value={
                      cityOpt ||
                      (isNewCity && cityInput
                        ? { label: cityInput, value: null }
                        : null)
                    }
                    loadOptions={loadCityOptions}
                    onChange={(selected) => {
                      setIsNewCity(false);
                      handleCityChange(selected);
                    }}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") {
                        setCityInput(inputValue);
                        setIsNewCity(true);
                        setCityOpt(null);
                        clearError("city");
                      }
                      return inputValue;
                    }}
                    placeholder="Search or enter city"
                    cacheOptions
                    defaultOptions
                    isClearable
                    isSearchable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "44px",
                        borderRadius: "12px",
                        fontSize: "14px",
                        borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                        boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                        "&:hover": { borderColor: "#454CF2" }
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      menu: (base) => ({
                        ...base,
                        fontSize: "12px",
                        zIndex: 10
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "220px",
                        overflowY: "auto"
                      })
                    }}
                  />
                </div>
              </div>

              <div className="project_popup_input_list">
                <p className="project_popup_project_text">State</p>
                <div className="project-input-error-wrapper">
                  <AsyncSelect
                    value={
                      stateOpt ||
                      (isNewState && stateInput
                        ? { label: stateInput, value: null }
                        : null)
                    }
                    loadOptions={loadStateOptions}
                    onChange={(selected) => {
                      setIsNewState(false);
                      handleStateChange(selected);
                      clearError("state");
                    }}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") {
                        setStateInput(inputValue);
                        setIsNewState(true);
                        setStateOpt(null);
                      }
                      return inputValue;
                    }}
                    placeholder="Search or enter state"
                    cacheOptions
                    defaultOptions
                    isClearable
                    isSearchable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "44px",
                        borderRadius: "12px",
                        fontSize: "14px",
                        borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                        boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                        "&:hover": { borderColor: "#454CF2" }
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      menu: (base) => ({
                        ...base,
                        fontSize: "12px",
                        zIndex: 10
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "220px",
                        overflowY: "auto"
                      })
                    }}
                  />
                </div>
              </div>

              <div className="project_popup_input_list">
                <p className="project_popup_project_text">Country</p>
                <div className="project-input-error-wrapper">
                  <AsyncSelect
                    value={
                      countryOpt ||
                      (isNewCountry && countryInput
                        ? { label: countryInput, value: null }
                        : null)
                    }
                    loadOptions={loadCountryOptions}
                    onChange={(selected) => {
                      setIsNewCountry(false);
                      setCountryOpt(selected);
                      clearError("country");
                    }}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") {
                        setCountryInput(inputValue);
                        setIsNewCountry(true);
                        setCountryOpt(null);
                      }
                      return inputValue;
                    }}
                    placeholder="Search or enter country"
                    cacheOptions
                    defaultOptions
                    isClearable
                    isSearchable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "44px",
                        borderRadius: "12px",
                        fontSize: "14px",
                        borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                        boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                        "&:hover": { borderColor: "#454CF2" }
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      menu: (base) => ({
                        ...base,
                        fontSize: "12px",
                        zIndex: 10
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "220px",
                        overflowY: "auto"
                      })
                    }}
                  />
                </div>
              </div>

              <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Zones</p>
                <div className="project-input-error-wrapper">
                  <select
                    className="project-popup-input"
                    value={region}
                    onChange={(e) => {
                      setRegion(e.target.value);
                      clearError("region");
                    }}
                  >
                    <option value="" disabled>
                      Select Zones
                    </option>
                    <option value="North">North</option>
                    <option value="West">West</option>
                    <option value="South">South</option>
                    <option value="East">East</option>
                  </select>
                </div>
              </div>

              <div className='project_popup_input_list'>
                <p className="project_popup_project_text">Business Place</p>
                <div className="project-input-error-wrapper">
                  <input
                    type=""
                    className="project-popup-input"
                    value={businessPlace || ""}
                    placeholder="Business Place"
                    disabled
                    style={{
                      margin: "0px",
                      backgroundColor: "#F5F7FA",
                      cursor: "not-allowed"
                    }}
                  />
                </div>
              </div>

              <div className="project_popup_input_list">
                <p className="project_popup_project_text">Mail ID</p>

                <div className="project-popup-input mail-pill-container">
                  {mailIds.map((mail, index) => (
                    <span className="mail-pill" key={index}>
                      {mail}
                      <span
                        className="mail-pill-remove"
                        onClick={() => removeMail(mail)}
                      >
                        ×
                      </span>
                    </span>
                  ))}

                  <input
                    type="text"
                    value={mailInput}
                    onChange={(e) => setMailInput(e.target.value)}
                    onKeyDown={handleMailKeyDown}
                    placeholder={mailIds.length === 0 ? "Enter mail id & press Enter" : ""}
                    className="mail-pill-text-input"
                    style={{ margin: '0px', padding: '0px' }}
                  />
                </div>
              </div>

            </div>
          </div>

          <div className="project_popup_job_cards">
            <p className="project_popup_project_text">Job Cards:</p>
            <div className="project_card_list">
              {selectedJobs.map((jobId, index) => {
                const job = jobOptions.find(j => j.value === jobId);
                return (
                  <div key={index} className="project_card_item">
                    <span>{job ? job.label : jobId}</span>
                    <button className="project_card_remove" onClick={() => handleRemoveJob(jobId)}>×</button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className='project_add_charges_section'>
          <h3 className='project_add_charges_heading'>Add Charges</h3>
          <div className='project_multiple_charge_item' style={{ marginBottom: '20px', width: '500px' }}>
            <div className='project_charge_field'>
              <p className='project_sub_heading'>Add Multiple Charges</p>
              <AsyncSelect
                isMulti
                value={[]}
                inputValue={chargeInputValue}
                onInputChange={setChargeInputValue}
                onChange={(selectedOptions = []) => {
                  const currentSelections = chargeItems
                    .filter(item => item.charge_id)
                    .map(item => ({
                      value: item.charge_id,
                      label: item.label
                    }));
                  const newSelections = selectedOptions.filter(
                    opt => !currentSelections.some(item => item.value === opt.value)
                  );

                  if (newSelections.length > 0) {
                    const newChargeItems = [
                      ...chargeItems.filter(item => item.charge_id),
                      ...newSelections.map(opt => ({
                        charge_id: opt.value,
                        label: opt.label,
                        supporting_doc: false
                      })),
                      ...chargeItems.filter(item => !item.charge_id)
                    ];

                    setChargeItems(newChargeItems);
                    clearError("charges");
                    setMultiSelectedCharges(newChargeItems
                      .filter(item => item.charge_id)
                      .map(item => ({
                        value: item.charge_id,
                        label: item.label
                      }))
                    );
                  }
                }}
                loadOptions={loadMultiChargeOptions}
                placeholder="Search and select multiple charges..."
                cacheOptions
                onFocus={() => {
                  loadMultiChargeOptions('', (options) => setAllCharges(options));
                }}
                defaultOptions={allCharges}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                noOptionsMessage={({ inputValue }) =>
                  inputValue ? "No charge codes found" : "Type to search charge codes"
                }
                loadingMessage={() => "Searching..."}
                menuPortalTarget={document.body}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    width: '100%',
                    minHeight: '40px',
                    borderRadius: '12px',
                    fontSize: '14px',
                    borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                    boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                    '&:hover': {
                      borderColor: '#454CF2'
                    }
                  }),
                  multiValue: () => ({ display: 'none' }),
                  multiValueRemove: () => ({ display: 'none' }),
                  container: (base) => ({ ...base, width: '100%' }),
                  menu: (base) => ({ ...base, fontSize: '14px' }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: '180px',
                    overflowY: 'auto'
                  }),
                }}
                components={{
                  DropdownIndicator: null,
                  IndicatorSeparator: null,
                  MultiValueContainer: () => null,
                  Option: ({ children, ...props }) => {
                    const isSelected = chargeItems.some(
                      item => item.charge_id === props.value
                    );

                    return (
                      <components.Option {...props}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            cursor: 'pointer'
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();

                            // Check if already selected
                            const alreadySelected = chargeItems.some(
                              item => item.charge_id === props.value
                            );

                            if (alreadySelected) {
                              const filtered = chargeItems.filter(item => item.charge_id !== props.value);
                              setChargeItems(filtered);
                              setMultiSelectedCharges(filtered
                                .filter(item => item.charge_id)
                                .map(item => ({
                                  value: item.charge_id,
                                  label: item.label
                                }))
                              );
                            } else {
                              const newChargeItems = [
                                ...chargeItems.filter(item => item.charge_id),
                                {
                                  charge_id: props.value,
                                  label: props.label || `Charge ${props.value}`,
                                  supporting_doc: false
                                },
                                ...chargeItems.filter(item => !item.charge_id)
                              ];

                              setChargeItems(newChargeItems);
                              clearError("charges");
                              setMultiSelectedCharges(newChargeItems
                                .filter(item => item.charge_id)
                                .map(item => ({
                                  value: item.charge_id,
                                  label: item.label
                                }))
                              );
                            }

                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            style={{ marginRight: 8 }}
                          />
                          {children}
                        </div>
                      </components.Option>
                    );
                  }
                }}
              />
            </div>
          </div>

          <div className='project_add_charges_content'>
            {chargeItems.map((item, index) => (
              <div className='project_charge_item' key={`${item.charge_id}-${index}`} style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px' }}>
                {/* Charge Dropdown */}
                <div className='project_charge_field' style={{ flex: 1 }}>
                  {index === 0 && <p className='project_sub_heading'>Charges <span style={{ color: 'red' }}>*</span></p>}
                  <AsyncSelect
                    value={
                      item.charge_id
                        ? { value: item.charge_id, label: item.label || `Charge ${item.charge_id}` }
                        : null
                    }
                    onChange={(selectedOption) => {
                      const selectedId = selectedOption?.value;
                      const isDuplicate = chargeItems.some(
                        (ci, idx) => idx !== index && ci.charge_id === selectedId
                      );

                      if (isDuplicate) {
                        toast.error("This charge is already selected.");
                        return;
                      }

                      const newChargeItems = [...chargeItems];
                      newChargeItems[index] = {
                        charge_id: selectedId || '',
                        label: selectedOption?.label || '',
                        supporting_doc: selectedOption ? item.supporting_doc : false,
                        sales_supporting_doc: false,
                        cost_supporting_doc: false
                      };
                      setChargeItems(newChargeItems);
                      clearError("charges");
                      const selectedCharges = newChargeItems
                        .filter(c => c.charge_id)
                        .map(c => ({ value: c.charge_id, label: c.label || `Charge ${c.charge_id}` }));
                      setMultiSelectedCharges(selectedCharges);
                    }}
                    loadOptions={loadChargeOptions}
                    placeholder="Select Charge Code"
                    cacheOptions
                    defaultOptions
                    isClearable
                    noOptionsMessage={({ inputValue }) =>
                      inputValue ? "No charge codes found" : "Type to search charge codes"
                    }
                    loadingMessage={() => "Searching..."}
                    menuPortalTarget={document.body}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        width: '100%',
                        minHeight: '40px',
                        borderRadius: '12px',
                        fontSize: '14px',
                        borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                        boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                        '&:hover': {
                          borderColor: '#454CF2'
                        }
                      }),
                      container: (base) => ({
                        ...base,
                        width: '100%'
                      }),
                      menu: (base) => ({
                        ...base,
                        fontSize: '14px',
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: '180px',
                        overflowY: 'auto'
                      }),
                    }}
                  />
                  {errors.charges && (
                    <span className="field-error">{errors.charges}</span>
                  )}
                </div>

                {/* Sales Supporting Doc */}
                <div className='project_support_doc_field'>
                  {index === 0 && <p className='project_sub_heading'>Sales Supporting Docs</p>}
                  <div className='project_checkbox_container'>
                    <input
                      type='checkbox'
                      id={`sales-doc-${item.charge_id}-${index}`}
                      className='project_checkbox'
                      checked={item.sales_supporting_doc}
                      onChange={() => {
                        const newChargeItems = [...chargeItems];
                        newChargeItems[index].sales_supporting_doc = !newChargeItems[index].sales_supporting_doc;
                        setChargeItems(newChargeItems);
                        clearError("charges");
                      }}
                    />
                    <label htmlFor={`sales-doc-${item.charge_id}-${index}`}></label>
                  </div>
                </div>

                {/* Cost Supporting Doc */}
                <div className='project_support_doc_field'>
                  {index === 0 && <p className='project_sub_heading'>Cost Supporting Docs</p>}
                  <div className='project_checkbox_container'>
                    <input
                      type='checkbox'
                      id={`cost-doc-${item.charge_id}-${index}`}
                      className='project_checkbox'
                      checked={item.cost_supporting_doc}
                      onChange={() => {
                        const newChargeItems = [...chargeItems];
                        newChargeItems[index].cost_supporting_doc = !newChargeItems[index].cost_supporting_doc;
                        setChargeItems(newChargeItems);
                        clearError("charges");
                      }}
                    />
                    <label htmlFor={`cost-doc-${item.charge_id}-${index}`}></label>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div
            className="add-charges-add-section"
            onClick={() => {
              setChargeItems([...chargeItems, { charge_id: '', label: '', supporting_doc: false }]);
            }}
          >
            <img src={plus_icon} alt="Add new charge" />
            Add New
          </div>
        </div>

      </div>
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
}

export default ProjectCreation;